import React, {Component, Fragment} from "react";
import {Col, Container, Image, Row} from "react-bootstrap";
import {Link} from "react-router-dom";
import Icon, {bolt, brain, bullsEyeArrow, handRock, icnDownloadReport, running, shield, star} from "../../Icon";
import ShadowScrollbars from "../../custom_scrollbars/ShadowScrollbars";
import PlayerAbilityCard from "../../../ui/cards/PlayerAbilityCard";
import InfoCard from "./InfoCard";
import VideosPerMatchModal from "../../../pages/dashboard/full_profile/modals/VideosPerMatchModal";
import MoreInformationModal from "../../../pages/dashboard/full_profile/tabs/scouting_reports_tab/MoreInformationModal";
import DownloadReportModal from "../../../ui/modals/DownloadReportModal";

// Style file
import '../../../../assets/sass/global/tabs/scouting-reports-tab-base/player-report.scss';
const items = [
    {title: 'Overall', description: 'A good passer Playing in forward', value: 72, attachments: [{name: 'Adel', type: 'pdf'}]},
    {title: 'Overall', description: 'A good passer Playing in forward', value: 72, attachments: []},
    {title: 'Overall', description: 'A good passer Playing in forward', value: 72, attachments: []},
    {title: 'Overall', description: 'A good passer Playing in forward', value: 72, attachments: []},
    {title: 'Overall', description: 'A good passer Playing in forward', value: 72, attachments: []},
];

const playerAbilities = [
    {title: 'Attacking', icon: bullsEyeArrow, items: items},
    {title: 'Skills', icon: handRock, items: items},
    {title: 'Movement', icon: running, items: items},
    {title: 'Power', icon: bolt, items: items},
    {title: 'bolt', icon: brain, items: items},
    {title: 'Defence', icon: shield, items: items},
    {title: 'Goal Keeping', icon: bolt, items: items},
    {title: 'Specialities', icon: star, items: items},
];

const videos = [];


class PlayerReport extends Component {
    state = {
        modal: {
            selected: null,
            extras: null
        }
    };

    /**
     * Renders the report of the player.
     * @returns {React.ReactNode} The player report.
     */
    render = () => {
        return (
            this.wrapWithinScrollbar(
                <div className="player-report">
                    {this.renderReportHeader()}
                    {this.renderContent()}
                    {this.renderModals()}
                </div>
            )
        );
    };

    /**
     * Renders the header of the player report.
     * @returns {React.ReactNode} The report header.
     */
    renderReportHeader = () => {
        const {name, teamName, avatar} = this.props;

        return (
            <div className="report-header">
                <div className="d-flex">
                    <Image className="avatar" src={avatar} roundedCircle={true}/>
                    <div className="information">
                        <div className="name"> {name} </div>
                        <div className="d-flex">
                            <div className="team"> {teamName} </div>
                            <div className="more-info" onClick={this.handleMoreInformationClick}> See More Info </div>
                        </div>
                    </div>
                </div>
                <div><Icon svg={icnDownloadReport} onClick={this.handleExportReport} className="primary"/></div>
            </div>
        )
    };

    /**
     * Renders the body content of the player report.
     * @returns {React.ReactNode} The body content.
     */
    renderContent = () => {
        return (
            <Container fluid={true}>
                <Row className="overview report-row">
                    <Col lg="2" xs="6">
                        <PlayerReport.InfoCard title="Over All Score" description="83"/>
                    </Col>
                    <Col lg="10" xs="6">
                        <PlayerReport.InfoCard title="Over All Evaluation Comment" description="Dustin is the calm player and has a good control over the ball and mind, Good Passing and Shooting skills"/>
                    </Col>
                </Row>
                <Row className="report-row">
                    <Col>
                        <div className="text-header"> Evaluation Scores</div>
                    </Col>
                </Row>
                <Row className="report-row">
                    {playerAbilities.map((playerAbility, index) =>
                        <Col lg="6" xs="12" key={index}>
                            <PlayerReport.PlayerAbility title={playerAbility.title} icon={playerAbility.icon} items={playerAbility.items} onAttachmentClick={() => this.setModalShow(VideosPerMatchModal.Name, true)}/>
                        </Col>
                    )}
                </Row>
            </Container>
        );
    };

    /**
     * Wraps the content within scrollbar.
     * @param content {React.ReactNode} The content witch renders within scrollbar.
     * @returns {React.ReactNode} The wrapped component.
     */
    wrapWithinScrollbar = (content) => {
        return (<ShadowScrollbars> {content} </ShadowScrollbars>);
    };


    renderModals = () => {
        const {modal} = this.state;
        const {selected, extras} = modal;

        return (
            <Fragment>
                <VideosPerMatchModal videos={videos} show={selected === VideosPerMatchModal.Name} onHide={() => this.setModalShow(VideosPerMatchModal.Name, false)}/>
                <DownloadReportModal show={selected === DownloadReportModal.Name} onHide={() => this.setModalShow(DownloadReportModal.Name, false)}/>
                <MoreInformationModal show={selected === MoreInformationModal.Name} onHide={() => this.setModalShow(MoreInformationModal.Name, false)}/>
            </Fragment>
        );
    };


    setModalShow = (modal, visible) => {

        this.setState({
            ...this.state,
            modal: {
                ...this.state.modal,
                selected: visible ? modal : undefined,
            }
        });
    };

    /**
     * Export report handler.
     * @param event
     */
    handleExportReport = (event) => {
        this.setModalShow(DownloadReportModal.Name, true);
    };


    /**
     * Export report handler.
     * @param event
     */
    handleMoreInformationClick = (event) => {
        this.setModalShow(MoreInformationModal.Name, true);
    };


}

PlayerReport.PlayerAbility = PlayerAbilityCard;
PlayerReport.InfoCard = InfoCard;

export default PlayerReport;
